import React from "react";

const InvoiceStatus = ({status}) => {

    let state;

    switch (status) {
        case 'paid':
        case 'part-refund':
            state = {status:'Paid', bgColor:'#31a331'};   // Green
            break;

        case 'disputed':
            state = {status:'Disputed', bgColor:'#bd0007'}; // Red
            break;

        case 'refund':
            state = {status:'Refund', bgColor:'#8d8c8c'}; // Gray
            break;

        default:
            state = {status:status, bgColor:'#cf9a0b'};  // Yellow
    }

    const classes =  {
        textBox : {
            display: 'inline-block',
            color: 'white',
            backgroundColor: state.bgColor,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 11,
            fontWeight: 500,
            borderRadius: 2
        }
    };

    return (
        <div style={classes.textBox}> {state.status} </div>
    )
}

export default InvoiceStatus;